import { c as _c } from "react/compiler-runtime";
import { Button, type SxProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ButtonProps } from './ButtonProps';
import { defaultButtonStyles } from './defaultButtonStyles';
export function SecondaryButton(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SecondaryButtonStyled variant="outlined" {...props} role="button">{props.text}</SecondaryButtonStyled>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
const SecondaryButtonStyled = styled(Button, {})(({
  theme
}) => ({
  ...defaultButtonStyles,
  ...({
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    '&:active': {
      border: `1px solid ${theme.palette.action.active}`,
      color: theme.palette.action.active
    },
    '&:hover': {
      color: theme.palette.primary.main
    },
    '&.Mui-disabled': {
      border: `1px solid ${theme.palette.action.disabled}`,
      color: theme.palette.action.disabled
    }
  } as SxProps)
}));